"use client";

import { c as _c } from "react/compiler-runtime";
import { Mail, Bell, Calendar, FileSearch, ShieldCheck, Sparkles } from "lucide-react";
import { useTranslations } from "next-intl";
export function FeaturesGrid() {
  const $ = _c(23);
  const t = useTranslations("landing.featuresGrid");
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  if ($[0] !== t) {
    const features = [{
      icon: Mail,
      titleKey: "items.emailReply.title",
      descriptionKey: "items.emailReply.description",
      color: "text-blue-600 dark:text-blue-400",
      bg: "bg-blue-50 dark:bg-blue-900/20",
      hoverBg: "group-hover:bg-blue-100 dark:group-hover:bg-blue-900/40"
    }, {
      icon: Bell,
      titleKey: "items.notifications.title",
      descriptionKey: "items.notifications.description",
      color: "text-purple-600 dark:text-purple-400",
      bg: "bg-purple-50 dark:bg-purple-900/20",
      hoverBg: "group-hover:bg-purple-100 dark:group-hover:bg-purple-900/40"
    }, {
      icon: Calendar,
      titleKey: "items.calendar.title",
      descriptionKey: "items.calendar.description",
      color: "text-teal-600 dark:text-teal-400",
      bg: "bg-teal-50 dark:bg-teal-900/20",
      hoverBg: "group-hover:bg-teal-100 dark:group-hover:bg-teal-900/40"
    }, {
      icon: FileSearch,
      titleKey: "items.rag.title",
      descriptionKey: "items.rag.description",
      color: "text-amber-600 dark:text-amber-400",
      bg: "bg-amber-50 dark:bg-amber-900/20",
      hoverBg: "group-hover:bg-amber-100 dark:group-hover:bg-amber-900/40"
    }, {
      icon: ShieldCheck,
      titleKey: "items.security.title",
      descriptionKey: "items.security.description",
      color: "text-green-600 dark:text-green-400",
      bg: "bg-green-50 dark:bg-green-900/20",
      hoverBg: "group-hover:bg-green-100 dark:group-hover:bg-green-900/40"
    }, {
      icon: Sparkles,
      titleKey: "items.ai.title",
      descriptionKey: "items.ai.description",
      color: "text-rose-600 dark:text-rose-400",
      bg: "bg-rose-50 dark:bg-rose-900/20",
      hoverBg: "group-hover:bg-rose-100 dark:group-hover:bg-rose-900/40"
    }];
    t4 = "bg-gray-50 py-24 dark:bg-gray-900/50";
    t2 = "container mx-auto px-4";
    const t5 = t("title");
    let t6;
    if ($[6] !== t5) {
      t6 = <h2 className="mb-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl dark:text-white">{t5}</h2>;
      $[6] = t5;
      $[7] = t6;
    } else {
      t6 = $[7];
    }
    const t7 = t("subtitle");
    let t8;
    if ($[8] !== t7) {
      t8 = <p className="text-lg text-gray-600 dark:text-gray-300">{t7}</p>;
      $[8] = t7;
      $[9] = t8;
    } else {
      t8 = $[9];
    }
    if ($[10] !== t6 || $[11] !== t8) {
      t3 = <div className="mx-auto mb-16 max-w-3xl text-center">{t6}{t8}</div>;
      $[10] = t6;
      $[11] = t8;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    t0 = "mx-auto grid max-w-6xl grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3";
    t1 = features.map((feature, index) => <div key={index} className="group rounded-2xl bg-white p-6 shadow-sm ring-1 ring-gray-200/50 transition-all ring-inset hover:shadow-md dark:bg-gray-900 dark:ring-white/10"><div className={`h-12 w-12 rounded-xl ${feature.bg} ${feature.hoverBg} mb-5 flex items-center justify-center transition-colors`}><feature.icon className={`h-6 w-6 ${feature.color}`} /></div><h3 className="mb-2 text-lg font-bold text-gray-900 dark:text-white">{t(feature.titleKey)}</h3><p className="text-sm leading-relaxed text-gray-600 dark:text-gray-400">{t(feature.descriptionKey)}</p></div>);
    $[0] = t;
    $[1] = t0;
    $[2] = t1;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
  } else {
    t0 = $[1];
    t1 = $[2];
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
  }
  let t5;
  if ($[13] !== t0 || $[14] !== t1) {
    t5 = <div className={t0}>{t1}</div>;
    $[13] = t0;
    $[14] = t1;
    $[15] = t5;
  } else {
    t5 = $[15];
  }
  let t6;
  if ($[16] !== t2 || $[17] !== t3 || $[18] !== t5) {
    t6 = <div className={t2}>{t3}{t5}</div>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t5;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  let t7;
  if ($[20] !== t4 || $[21] !== t6) {
    t7 = <section className={t4}>{t6}</section>;
    $[20] = t4;
    $[21] = t6;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
}